import { } from './js-custom-select.min';
import Autosize from '../../node_modules/autosize/dist/autosize.min';

/**
 * JS Custom Select
 * Originally managed by the package however it uses `touchend` to listen to the dropdown selection on mobile.
 * This event causes the dropdown to close whenever you're trying to scroll the dropdown selection, before you actually make your selection.
 * The code has been pulled out of the package and `touchend` replaced with `click`.
 */

class Form {
	constructor() {
	}

	init() {
		const self = this;

		// form.customizeDropDown();
		// form.resizeTextArea( document.querySelectorAll('textarea') );

		self.customizeDropDown();
		self.resizeTextArea(document.querySelectorAll('textarea'));
		self.regenerateCustomDropdown();

		//Regenerate the form dropdown fields when the form is refreshed on submit. Can't use JS
		jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
			//Custom dropdown
			if (jQuery('#gform_' + form_id).find('select').hasClass('select-masked').length != 1)
				form.customizeDropDown();
			form.resizeTextArea(document.querySelectorAll('textarea'));
		});

	}

	regenerateCustomDropdown() {
		// Regenerate the form dropdown fields when the form is refreshed on submit. Can't use JS
		jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
			//Custom dropdown
			if (jQuery('#gform_' + form_id).find('select').hasClass('select-masked').length != 1)
				form.customizeDropDown();
			form.resizeTextArea();
		});
	}

	identifyChangedDropdown() {
		const changed_select = this;
		const changed_masked_dropdown = changed_select.nextSibling;
		const current_dropdown_option = changed_select.options[changed_select.selectedIndex].value;
		const unchanged_dropdown_identifier = 'select-unchanged';

		if (current_dropdown_option != '') {
			changed_masked_dropdown.classList.remove(unchanged_dropdown_identifier);
		} else {
			changed_masked_dropdown.classList.add(unchanged_dropdown_identifier);
		}
	}

	customizeDropDown() {

		const select_fields = document.querySelectorAll(' select ');
		let i = 0;
		let custom_select_classes = "custom-select-block";

		//Find all select fields
		if (select_fields.length > 0) {

			//loop through all select fields
			for (i = 0; i < select_fields.length; ++i) {
				const current_select = select_fields[i];

				//Skip masking if already masked
				if (current_select.className.indexOf('select-masked') !== -1) continue;

				//Mask each select field
				new jsCustomSelect(current_select, { search: false, initClass: custom_select_classes });
				//Add a class to identify the dropdown as already masked
				current_select.classList.add('select-masked');

				//Add a class to identify if the dropdown hasn't been selected
				const current_select_option = current_select.options[current_select.selectedIndex].value;
				if (current_select_option == '') {
					const current_masked_dropdown = current_select.nextSibling;
					current_masked_dropdown.classList.add('select-unchanged');
				}

				current_select.addEventListener('change', this.identifyChangedDropdown);

			}//end for

		}//end if

	} //end method customizeDropDown

	resizeTextArea(target) {
		Autosize(target);
	}

}//end Class Form

// Singleton
export var form = new Form();